import React, { useState } from "react";
import { Card } from "@ui/card";
import { ShadcnButton } from "@components/items/display/ShadcnButton";
import { Input } from "@ui/input";
import { Controller, useForm } from "react-hook-form";
import ActivateSubscriptionAlert from "../ActivateSubscriptionAlert";
import { SVG } from "@components/items/common/SVG";
import { redeemb2bVoucher } from "@lib/stores";
import { getMyPlansAsync } from "@lib/fetchers/plans";
import { useB2B } from "@modules/content/B2BContext";
import TranslatedText from "@components/items/display/TranslatedText";
import { translate } from "@modules/localizations/translate";

const WajeezCompaniesTab = () => {
  const { b2B, toggleB2B } = useB2B();

  const [openDialog, setOpenDialog] = useState<boolean>(false);
  type Inputs = {
    code: string;
  };

  const {
    control,
    handleSubmit,
    formState: { errors, isValid },
    reset,
  } = useForm<Inputs>({
    defaultValues: {
      code: "",
    },
  });
  const isDisabled = !isValid;

  const onSubmit = (data: Inputs) => {
    redeemb2bVoucher(data, async () => {
      await getMyPlansAsync();
      toggleB2B(!b2B?.isB2B);
      reset();
      window.location.reload();
      setOpenDialog(true);
    });
  };

  return (
    <div className="flex w-full items-center justify-center p-5">
      <ActivateSubscriptionAlert open={openDialog} setOpen={setOpenDialog} />
      <Card className="flex w-1/2 flex-col items-center justify-center gap-3 border-none bg-[#D9D9D9]/15 p-5">
        <TranslatedText
          text={`settings.titles.${"activate the subscription coupon"}`}
          className="text-[18px] text-black dark:text-white"
        />
        <SVG src="/assets/icons/voucher.svg" className="h-[120px] w-[150px]" />
        <TranslatedText
          text={`settings.titles.${"enter the subscription code"}`}
          className="text-[12px] font-medium text-black dark:text-white"
        />
        <form
          className="flex w-full flex-col items-center justify-center gap-4"
          onSubmit={handleSubmit(onSubmit)}
        >
          <Controller
            name="code"
            control={control}
            rules={{
              required: {
                value: true,
                message: translate(`settings.errors.${"voucher is required"}`),
              },
            }}
            render={({ field }) => (
              <div className="flex w-full flex-col items-center justify-center gap-2">
                <Input
                  className={`no-outline w-1/3 rounded-none border-0 border-b-2 border-b-black bg-transparent focus-visible:ring-0 focus-visible:ring-offset-0 dark:border-b-white`}
                  {...field}
                />
                <p className="ms-2 text-[12px] text-red-500">
                  {errors?.code?.message}
                </p>
              </div>
            )}
          />

          <ShadcnButton
            className="px-10 py-4"
            disabled={isDisabled}
            type="submit"
          >
            <TranslatedText
              text={`settings.buttons.${"verify"}`}
              className="text-[16px] font-normal text-white"
            />
          </ShadcnButton>
        </form>
      </Card>
    </div>
  );
};

export default WajeezCompaniesTab;
